import View from '../../../Core/View.js';
import BoatExplorer from './BoatExplorer.js';

class BoatExplorerSlider extends View {

	initialize(options) {

		// cache selectors
		this.$sliderButton = this.$el.find('.boat-explorer__slider--button');
		this.$sliderBar = this.$el.find('.boat-explorer__slider--bar');
		this.$doc = $(document);
		this.$window = $(window);

		// Position things
		this.$sliderButton.css("left", (this.$sliderBar.width() / 2 ) - (this.$sliderButton.width() / 2) + 'px');
		this.container = this.$sliderBar.get(0).getBoundingClientRect();

		this.totalFrames = BoatExplorer.SPRITE_ROWS * BoatExplorer.SPRITE_COLS;

		// Prebind things
		this.handleDragMoveBound = this._handleDragMove.bind(this);
		this.handleDragStopBound = this._handleDragStop.bind(this);

		// Add listener
		this.$window.resize(() => this.container = this.$sliderBar.get(0).getBoundingClientRect());
		this.$sliderButton.on('touchstart mousedown', this._handleDragStart.bind(this));
		this.$el.on('touchstart mousedown', this._handleBarClick.bind(this));
		this.callback = options.onUpdate;

		this.callback(50);
	}

	/**
	 *
	 * @private
	 */
	_handleDragStart(event) {
		this.$doc.on('touchend mouseup', this.handleDragStopBound);
		this.$doc.on('touchmove mousemove', this.handleDragMoveBound);
		this.$doc.on('touchleave mouseleave', this.handleDragStopBound);
		const offsetX = event.offsetX ? event.offsetX : (this.$sliderButton.width() / 2);
		this.mousePositionOnButton = offsetX % this.$sliderButton.width();

	}

	/**
	 *
	 * @param event
	 * @private
	 */
	_handleDragMove(event) {
		const positionX = event.pageX ? event.pageX : event.originalEvent.touches[0].pageX;
		const correctedMousePos = (positionX - this.container.left) - this.mousePositionOnButton;
		this.buttonPos = this._handleButtonPosition(correctedMousePos);
		this._calculateAngle(event);
		this.$sliderButton.css("left", this.buttonPos + 'px');
	}

	/**
	 *
	 * @param event
	 * @private
	 */
	_handleDragStop(event) {
		this.$doc.off('touchend mouseup', this.handleDragStopBound);
		this.$doc.off('touchmove mousemove', this.handleDragMoveBound);
		this.$doc.off('touchleave mouseleave', this.handleDragStopBound);
	}

	/**
	 *
	 * @param event
	 * @private
	 */
	_handleBarClick(event) {
		this.mousePositionOnButton = this.$sliderButton.width() / 2;
		this._handleDragMove(event);
	}

	/**
	 *
	 * @param mousePosition
	 * @returns {*}
	 * @private
	 */
	_handleButtonPosition(mousePosition) {
		const sliderButtonDiameter = parseFloat(this.$sliderButton.width() / 2);
		const sliderStart = 0 - sliderButtonDiameter;
		const sliderEnd = this.container.width - sliderButtonDiameter;

		if (mousePosition < sliderStart) {
			mousePosition = 0;
			return mousePosition - sliderButtonDiameter;
		} else if (mousePosition > sliderEnd) {
			mousePosition = sliderEnd;
			return mousePosition;
		}
		else
			return mousePosition;
	}

	/**
	 *
	 * @param event
	 * @private
	 */
	_calculateAngle(event) {
		const pageX = event.pageX ? event.pageX : event.originalEvent.touches[0].pageX;
		const correctedMousePos = (pageX - this.container.left);
		const maxRange = this.container.width;
		var percentage = Math.floor((correctedMousePos / maxRange) * 100);
		if (percentage > 100) {
			percentage = 100
		} else if (percentage < 0) {
			percentage = 0;
		}
		this.callback(percentage);

	}
}

export default BoatExplorerSlider;


// WEBPACK FOOTER //
// ./js/Views/Modules/BoatExplorer/BoatExplorerSlider.js